const config = {
  sitekey: '6Lch-_wUAAAAAAb-KkroXz9hkopPeQHHQc8W9S5G',
  eosApiHost: 'https://jungle.eosio.cr'
}

export default config
